import PageDescription from './PageDescription';

export default PageDescription;
